import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { noneToEmptyStr } from '@/utils/util'
import router from '../router/index'

if (process.env.NODE_ENV === 'development') {
  // dev url
  axios.defaults.baseURL = '/dev-api/'
} else {
  // build url
  axios.defaults.baseURL = '/api/'
}
// axios.defaults.baseURL = '/api/';

if (
  location.hostname === 'localhost' ||
  location.hostname === 'new.p2ps.dev.s2p.cc' ||
  location.hostname === 'new.p2ps.test.s2p.cc'
) {
  // axios.self_ws = 'ws://192.168.1.200:8082';
  axios.self_ws = 'ws://ws.s2p.cc:2120'
} else {
  // axios.self_ws = 'ws://172.18.0.12:8082';
  // axios.self_ws = 'ws://sio.p2ps.vip:8082';
  // axios.self_ws = 'ws://123.56.222.231:8082';
  axios.self_ws = 'ws://ws.s2p.cc:2120'
}
// axios.defaults.withCredentials = true;

// 返回错误码处理
function errorCodeHandle (codeStatus) {
  switch (codeStatus) {
    case 401:
      router.push({ name: 'login' })
  }
}

// 表单请求
axios.formRequest = axios.create({
  baseUrl: axios.defaults.baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  transformRequest: [
    function (data = {}) {
      try {
        if (returnCitySN) {
          data.ip = returnCitySN.cip
        }
      } catch (error) { }
      //获取url中#后面的地址
      let str = document.URL
      let start = str.indexOf('#') + 1
      if (str.indexOf('redirect?toPath=') > -1) {
        start += 17
        str = str.replace(/%2F/g, '/')
      }

      if (!data.web_path) {
        data.web_path = str.substr(start)
      }

      if (data && !data.hasOwnProperty('function_name')) {
        data['function_name'] = store.state.crumbs
        if (str && str.includes('is_future')) {
          if (data['function_name'] && data['function_name'].includes('部门管理')) {
            data['function_name'] = data['function_name'].replace(
              /部门管理/g,
              '未来框架',
            )
          }

          if (data['function_name'] && data['function_name'].includes('辖区关系/产品/终端关联')) {
            data['function_name'] = data['function_name'].replace(
              /辖区关系\/产品\/终端关联/g,
              '未来三者关系',
            )
          }
          if (data['function_name'] && data['function_name'].includes('岗位/产品/终端关联')) {
            data['function_name'] = data['function_name'].replace(
              /岗位\/产品\/终端关联/g,
              '未来三者关系',
            )
          }
        }
      }
      if (data && data['function_name'] == undefined) {
        delete data['function_name']
      }
      if (Object.prototype.toString.call(data) === '[object Object]') {
        for (let k in data) {
          data[k] = noneToEmptyStr(data[k])
        }
      }
      return qs.stringify(data, { arrayFormat: 'indices' })
    },
  ],
})
axios.formRequest.interceptors.request.use(
  function (config) {
    const href = window.location.href

    if (href.split('?') && href.split('?').length > 1) {
      const isFutureText = href.split('?')[1]
      if (isFutureText && isFutureText.includes('is_future')) {
        console.log(config)
        config.data = {
          ...config.data,
          is_future: 1,
          // 未来组织架构 未来三者关系 如果是从这两个页面进去的话 路由里面会带个    is_future: 1参数
          // 如果有这个参数就要传这个is_future: 1
        }
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

axios.formRequest.interceptors.response.use(
  function (response) {
    return response.data
  },
  function (error) {
    console.log(error)
    if (error.response) {
      errorCodeHandle(error.response.status)
    }

    return Promise.reject(error)
  },
)

// 导入表格
axios.importExcel = axios.create({
  baseUrl: axios.defaults.baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})
axios.importExcel.interceptors.response.use(
  function (response) {
    console.log(response)
    return response.data
  },
  function (error) {
    console.log(error,'======================error');
    if (error.response) {
      errorCodeHandle(error.response.status)
    } else {
      // this.$message.error('文件上传不成功，请重新上传！',4)
      return {
        data: {},
        status: 911,
        msg: '文件上传不成功，请重新上传！',
      }
    }

    return Promise.reject(error)
  },
)
axios.importExcel.interceptors.request.use(
  function (config) {
    const href = window.location.href
    if (href.split('?') && href.split('?').length > 1) {
      const isFutureText = href.split('?')[1]
      if (isFutureText && isFutureText.includes('is_future')) {
        config.data.append('is_future', 1)
        let functionName = config.data.get('function_name')
          if (functionName && functionName.includes('部门管理')) {
            config.data.set(
              'function_name',
              functionName.replace(/部门管理/g, '未来框架'),
            )
          }
  
          if (functionName && functionName.includes('辖区关系/产品/终端关联')) {
            config.data.set(
              'function_name',
              functionName.replace(/辖区关系\/产品\/终端关联/g, '未来三者关系'),
            )
          }
        
      }
    }
    console.log(config, '我是configggggggggggggggggg')
    console.log(config.data.get('function_name'))
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

// 导出表格
axios.exportExcel = axios.create({
  baseUrl: axios.defaults.baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  transformRequest: [
    function (data) {
      if (!data['function_name']) {
        //获取url中#后面的地址
        let str = document.URL
        data['function_name'] = store.state.crumbs

        if (str && str.includes('is_future')) {
          if (data['function_name'] && data['function_name'].includes('部门管理')) {
            data['function_name'] = data['function_name'].replace(
              /部门管理/g,
              '未来框架',
            )
          }

          if (data['function_name'] && data['function_name'].includes('辖区关系/产品/终端关联')) {
            data['function_name'] = data['function_name'].replace(
              /辖区关系\/产品\/终端关联/g,
              '未来三者关系',
            )
          }
        }
      }

      if (Object.prototype.toString.call(data) === '[object Object]') {
        for (let k in data) {
          data[k] = noneToEmptyStr(data[k])
        }
      }
      return qs.stringify(data, { arrayFormat: 'indices' })
    },
  ],
})
axios.exportExcel.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response) {
      errorCodeHandle(error.response.status)
    }

    return Promise.reject(error)
  },
)
axios.exportExcel.interceptors.request.use(
  function (config) {
    const href = window.location.href
    if (href.split('?') && href.split('?').length > 1) {
      const isFutureText = href.split('?')[1]
      if (isFutureText && isFutureText.includes('is_future')) {
        config.data = {
          ...config.data,
          is_future: 1,
          // 未来组织架构 未来三者关系 如果是从这两个页面进去的话 路由里面会带个    is_future: 1参数
          // 如果有这个参数就要传这个is_future: 1
        }
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

export default axios
